import React, { useContext, useEffect, useState } from "react";
import ListNumbers from "components/ListNumbers";
import Legend from "components/Legend";
import MainTitle from "components/MainTitle";
import Fieldset from "components/Fieldset";
import { createPagination } from "./createPagination";
import NumberListApi from "core/api/numberList/NumberListApi";
import { store } from "store.js";
import ListNumbersTitular from "components/ListNumbers/ListNumbersTitular";
import { Text } from "mondrian-react";
import Analytics from "core/Utils/Analytics";
import Modal from "components/Modal";

const ListNumbersPage = ({
  setForm,
  formData,
  navigation,
  setIsLoading,
  ...props
}) => {
  const [listNumber, setListNumber] = useState([]);
  const [listNumberDependent, setListNumberDependent] = useState([]);
  const [modalContent, setModalContent] = useState(null);

  const globalState = useContext(store);
  const { state } = globalState;
  const { go } = navigation;
  const { accesstoken } = state;
  useEffect(
    function () {
      if (accesstoken) {
        loadNumberList(accesstoken);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [accesstoken]
  );


  
  async function loadNumberList(accesstoken) {
    setIsLoading(true);
    let result = await NumberListApi(accesstoken);
  
    let {
      dependent: dependentList = [],
      holder: holderList = [],
      error = null,
    } = result ?? {};
  
    setIsLoading(false);
    if (error != null) {
      setModalContent(error);
      const { message, originalMessage = message } = error.warning;
  
      Analytics().setErrorEvent({
        eventAction: "callback:meus-numeros",
        eventLabel: originalMessage,
        code: error?.errorCode
      });
      return null;
    }
    if (holderList.length) {
      setListNumber(holderList);
    }
    if (dependentList.length) {
      dependentList = dependentList.map(function (dependentInfo) {
        const { msisdn = "", segment = "", ...item } = dependentInfo;
        return { msisdn, segment, associated: item };
      });
      setListNumberDependent(dependentList);
    }
    setIsLoading(false);
  }
  

  const itemsPerPage = 5;
  const [page, setPage] = useState(1);
  const numberOfPages = Math.ceil(listNumber.length / itemsPerPage);

  if (!accesstoken) return null;
  let pagination = createPagination(
    page,
    setPage,
    numberOfPages,
    listNumber,
    itemsPerPage
  );
  function onRequestClose(data = {}) {
    setModalContent(null);
  }
  if (modalContent) {
    return <Modal onClose={onRequestClose} content={modalContent} />;
  }

  if (!listNumber.length && !listNumberDependent.length) {
    return (
      <>
        {!props.isLoading && (
          <>
            <MainTitle sm tabIndex="20">
              Meus números
            </MainTitle>
            <Text>Você não possui números na Claro</Text>
          </>
        )}
      </>
    );
  }

  return (
    <>
      <MainTitle sm tabIndex="20">
        Meus números
      </MainTitle>
      <Legend>
        <Text>
          Confira o(s) número(s) ativo(s) no seu CPF e se desejar, adicione um
          dependente a uma linha disponível para que ele tenha acesso aos sites
          e apps da Claro.
        </Text>
      </Legend>
      {listNumberDependent.length ? (
        <>
          <Legend> Você é dependente do(s) número(s):</Legend>
          <Fieldset>
            <div Style="">
              <ListNumbersTitular
                next={go}
                setCustomData={props.setCustomData}
                customData={props.customData}
                itemsPerPage={itemsPerPage}
                page={page}
                items={listNumberDependent}
                icon={"celular"}
              />
            </div>
          </Fieldset>
        </>
      ) : null}
      {listNumber.length ? (
        <>
          <Legend>Número(s) ativo(s) no seu CPF:</Legend>
          <Fieldset>
            <div Style="">
              <ListNumbers
                next={go}
                setCustomData={props.setCustomData}
                customData={props.customData}
                itemsPerPage={itemsPerPage}
                page={page}
                items={listNumber}
                icon={"celular"}
              />
            </div>
          </Fieldset>
          {(numberOfPages > 1 && (
            <div className="cred-Pagination">{pagination}</div>
          )) ||
            null}
        </>
      ) : null}
    </>
  );
};

export default ListNumbersPage;
